import { NonCachedSearchType } from 'interfaces'
import { StoreInstances } from 'src/store/StoreInstancesContainer'
import type { Filters, SortOrder } from 'src/store/models/SearchModels'

import { FilterGroupName } from 'results/constants'
import type { ResultStore } from 'results'
import type { SearchStore } from 'src/store/search/SearchStore'

const syncFirstSelectedFilterType = (
  resultsStore: ResultStore,
  filters: Filters
): void => {
  const brands = filters.find(
    (entry) => entry.groupName === FilterGroupName.BRANDS
  )
  const partType = filters.find(
    (entry) => entry.groupName === FilterGroupName.PART_TYPE
  )
  if (brands?.items.length) {
    resultsStore.setFirstSelectedFilterType(FilterGroupName.BRANDS)
    return
  }
  if (partType?.items.length) {
    resultsStore.setFirstSelectedFilterType(FilterGroupName.PART_TYPE)
    return
  }
  resultsStore.setFirstSelectedFilterType(undefined)
}

const saveStockPreference = (filters: Filters): void => {
  const stockFilter = filters.find(
    (entry) => entry.groupName === FilterGroupName.STOCK
  )
  if (stockFilter?.items?.[0]) {
    StoreInstances?.userStore?.saveStockFilterPreference(stockFilter.items[0])
  }
}

export const applyFilterSortDrawer = (
  resultsStore: ResultStore,
  searchStore: SearchStore,
  stagedFilters: Filters,
  stagedManufacturers: string[],
  stagedSort: SortOrder
): void => {
  const prevNonStockFilters = resultsStore.filters.some(
    (entry) => entry.groupName !== FilterGroupName.STOCK
  )

  resultsStore.setFilters(stagedFilters)
  resultsStore.setSelectedLinesManufacturers(stagedManufacturers)
  syncFirstSelectedFilterType(resultsStore, stagedFilters)
  saveStockPreference(stagedFilters)
  resultsStore.setSortOrder(stagedSort, false)
  resultsStore.clearResults()
  resultsStore.setIsLoading(true)

  const { lastNonCachedSearch } = resultsStore
  const { gfxLookupMade, lastTextSearched } = searchStore

  const nextNonStockFilters = stagedFilters.some(
    (entry) => entry.groupName !== FilterGroupName.STOCK
  )

  if (
    lastNonCachedSearch === NonCachedSearchType.searchByText &&
    (nextNonStockFilters || prevNonStockFilters)
  ) {
    resultsStore.filterAstPartSearch(lastTextSearched, stagedFilters)
    return
  }

  if (lastNonCachedSearch === NonCachedSearchType.searchByInterchange) {
    resultsStore.applyInterchangeSearchFilters()
    return
  }

  if (gfxLookupMade) {
    resultsStore.searchByGfxPartBin()
    return
  }

  resultsStore.searchByPartBin()
  resultsStore.setSortOrder(stagedSort, true)
}
